(function () {
    angular.module('components.externalForm')
        .factory('externalFormService', externalFormService);

    externalFormService.$inject = ['$http', '$sanitize', '$location'];
    function externalFormService($http, $sanitize, $location) {
        return {
            getForm: function (id, datatypeId) {
                return $http.get('/api/externalforms/form', {
                    cache: true,
                    params: {
                        id: id,
                        datatypeId: datatypeId
                    },
                    transformResponse: function (data, headers, status) {
                        var response = angular.fromJson(data);
                        if (status === 200) {
                            var queries = $location.search();
                            angular.forEach(response.fields, function (field) {
                                switch (field.name) {
                                    case "field[12]":
                                        field.value = $sanitize(queries.utm_source);
                                        break;
                                    case "field[18]":
                                        field.value = $sanitize(queries.utm_medium);
                                        break;
                                    case "field[21]":
                                        field.value = $sanitize(queries.utm_name);
                                        break;
                                    case "field[19]":
                                        field.value = $sanitize(queries.utm_term);
                                        break;
                                    case "field[20]":
                                        field.value = $sanitize(queries.utm_campaign);
                                        break;
                                }
                            })
                        }
                        return response;
                    }
                });
            }
        };
    }
})();